// ----------------------------------------------------------------------
// <copyright file="Izenda.Resizable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var PropTypes = React.PropTypes;
  var DraggableCore = require('react-draggable').DraggableCore;
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');
  var query = require('dom-helpers/query');
  var ResizableController = require('./Izenda.ResizableController');
  var Handle = ResizableController.Handle;
  var EventName = ResizableController.EventName;
  const { isEqual, assign, omit, assignAll, placeholder } = require('lodash/fp');

  var Resizable = React.createClass({
    propTypes: {
      [`${EventName.Resize}`]: PropTypes.func,
      [`${EventName.ResizeStart}`]: PropTypes.func,
      [`${EventName.ResizeStop}`]: PropTypes.func,
      style: PropTypes.object,
      children: PropTypes.element.isRequired,
      width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      draggableOptions: PropTypes.object,
      minConstraints: PropTypes.arrayOf(PropTypes.number),
      maxConstraints: PropTypes.arrayOf(PropTypes.number),
      topResize: React.PropTypes.bool,
      leftResize: React.PropTypes.bool,
      rightResize: React.PropTypes.bool,
      bottomResize: React.PropTypes.bool,
      topLeftResize: React.PropTypes.bool,
      topRightResize: React.PropTypes.bool,
      bottomLeftResize: React.PropTypes.bool,
      bottomRightResize: React.PropTypes.bool,
      topResizeClass: React.PropTypes.string,
      leftResizeClass: React.PropTypes.string,
      rightResizeClass: React.PropTypes.string,
      bottomResizeClass: React.PropTypes.string,
      topLeftResizeClass: React.PropTypes.string,
      topRightResizeClass: React.PropTypes.string,
      bottomLeftResizeClass: React.PropTypes.string,
      bottomRightResizeClass: React.PropTypes.string,
      resizableController: React.PropTypes.object
    },
    getDefaultProps: function() {
      return {
        minConstraints: [20, 20],
        maxConstraints: [Infinity, Infinity],
        topResize: false,
        leftResize: false,
        rightResize: false,
        bottomResize: false,
        topLeftResize: false,
        topRightResize: false,
        bottomLeftResize: false,
        bottomRightResize: false,
        topResizeClass: '',
        leftResizeClass: '',
        rightResizeClass: '',
        bottomResizeClass: '',
        topLeftResizeClass: '',
        topRightResizeClass: '',
        bottomLeftResizeClass: '',
        bottomRightResizeClass: ''
      };
    },
    componentWillMount: function() {
      var props = this.props;
      // Initial component variables
      this.controller =
        props.resizableController ||
        new ResizableController(0, 0, props.width, props.height, props.minConstraints, props.maxConstraints);
    },
    componentWillReceiveProps: function(nextProps) {
      if (!isEqual(this.props.minConstraints, nextProps.minConstraints)) {
        this.controller.setMinConstraints(nextProps.minConstraints);
      }
      if (!isEqual(this.props.maxConstraints, nextProps.maxConstraints)) {
        this.controller.setMaxConstraints(nextProps.maxConstraints);
      }
    },
    render: function() {
      var props = this.props;
      var child = React.Children.only(props.children);
      var width = props.width;
      var height = props.height;
      var className = classnames('izenda-Resizable', props.className, child.props.className);

      var rest = omit(
        [
          'children',
          'className',
          'width',
          'height',
          'minConstraints',
          'maxConstraints',
          'onResize',
          'onResizeStop',
          'onResizeStart',
          'style',
          'resizableController',
          'topResize',
          'leftResize',
          'rightResize',
          'bottomResize',
          'topLeftResize',
          'topRightResize',
          'bottomLeftResize',
          'bottomRightResize',
          'topResizeClass',
          'leftResizeClass',
          'rightResizeClass',
          'bottomResizeClass',
          'topLeftResizeClass',
          'topRightResizeClass',
          'bottomLeftResizeClass',
          'bottomRightResizeClass'
        ],
        props
      );

      var style = assign(props.style, child.props.style);

      var childProps = assignAll([rest, { width: width, height: height }, { style: style }, { className: className }]);

      var grandchildren = React.Children.toArray(child.props.children).concat(this.getHandles());

      return React.cloneElement(child, childProps, grandchildren);
    },
    getHandles: function() {
      var props = this.props;
      var resizerHandler = this.resizeHandler;

      var handleInfo = {
        [`${Handle.top}`]: {
          allow: props.topResize,
          className: classnames('izenda-Handle-HorizontalTop', props.topResizeClass)
        },
        [`${Handle.left}`]: {
          allow: props.leftResize,
          className: classnames('izenda-Handle-VerticalLeft', props.leftResizeClass)
        },
        [`${Handle.right}`]: {
          allow: props.rightResize,
          className: classnames('izenda-Handle-VerticalRight', props.rightResizeClass)
        },
        [`${Handle.bottom}`]: {
          allow: props.bottomResize,
          className: classnames('izenda-Handle-HorizontalBottom', props.bottomResizeClass)
        },
        [`${Handle.topLeft}`]: {
          allow: props.topLeftResize,
          className: classnames('izenda-Handle-CornerLeftTop', props.topLeftResizeClass)
        },
        [`${Handle.topRight}`]: {
          allow: props.topRightResize,
          className: classnames('izenda-Handle-CornerRightTop', props.topRightResizeClass)
        },
        [`${Handle.bottomLeft}`]: {
          allow: props.bottomLeftResize,
          className: classnames('izenda-Handle-CornerLeftBottom', props.bottomLeftResizeClass)
        },
        [`${Handle.bottomRight}`]: {
          allow: props.bottomRightResize,
          className: classnames('izenda-Handle-CornerRightBottom', props.bottomRightResizeClass)
        }
      };

      return placeholder(Handle)
        .chain()
        .values()
        .filter(function(handle) {
          return handleInfo[handle].allow;
        })
        .map(createResizeHandle)
        .value();

      function createResizeHandle(handle) {
        var info = handleInfo[handle];
        var handleClassName = classnames('js-resize-handle', info.className);
        return (
          <DraggableCore
            key={handle}
            onStop={resizerHandler(EventName.ResizeStop, handle)}
            onStart={resizerHandler(EventName.ResizeStart, handle)}
            onDrag={resizerHandler(EventName.Resize, handle)}
            {...props.draggableOptions}
          >
            <div className={handleClassName} />
          </DraggableCore>
        );
      }
    },
    synchSize: function() {
      var node = ReactDOM.findDOMNode(this);
      var props = this.props;
      var width = props.width;
      var height = props.height;
      var draggableOptions = props.draggableOptions;
      var offsetParent = draggableOptions ? draggableOptions.offsetParent : null;
      var position = query.position(node, offsetParent);

      width = position.width;
      height = position.height;

      this.controller.updatePosition(position.left, position.top, width, height);
    },
    resizeHandler: function(eventName, handle) {
      var controller = this.controller;
      var synchSize = this.synchSize;
      var resizeCallback = this.props[eventName];

      return function(e, dragData) {
        if (eventName === EventName.ResizeStart) {
          synchSize();
        }

        controller.resizeHandler(eventName, handle, dragData, resizeCallback);
      };
    }
  });

  module.exports = observer(Resizable);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Resizable.jsx